import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  fakeCall$(): Observable<string[]> {
    return of(['More updates to come!']);
  }
}
